import SecurityScopeQuestion from './SecurityScopeQuestion.component';

export default SecurityScopeQuestion;
